import { SecureRoute, useOktaAuth } from '@okta/okta-react'
import { FC, HTMLAttributes } from 'react'
import { Redirect, RouteProps } from 'react-router-dom'
import { RoleNames } from 'shared/models/Enum'
import { hasRole } from 'shared/utils/roleHelpers'

const ProtectedRoute: FC<
  { component: FC; requiredRole: RoleNames } & RouteProps &
    HTMLAttributes<HTMLDivElement>
> = ({ component: Component, requiredRole, ...rest }) => {
  const { authState } = useOktaAuth()

  return (
    <SecureRoute
      {...rest}
      render={props =>
        hasRole(authState, requiredRole) ? (
          <Component {...props} />
        ) : (
          <Redirect to='/home' />
        )
      }
    />
  )
}

export default ProtectedRoute
